import { useState } from 'react'
import type { Ref } from 'react'
import { anzahlwort, t } from './sprache'

/**
 * Die Dateiwahl — **ein Bauteil für die ganze Anwendung** (7.2 Abschnitt 27,
 * R949).
 *
 * **Der Befund vom 2026-10-03:** In der Importmaske stand der graue Knopf des
 * Browsers, „Dateien auswählen — Keine ausgewählt", in fremder Schrift. Die
 * Dateiwahl gab es an sechs Stellen in drei Bauweisen: dreimal je für sich
 * gebaut in der Gestalt der Anwendung, dreimal als Feld des Browsers.
 *
 * **Ein `label` und kein Knopf, der ein verstecktes Feld anklickt** (R451,
 * R454 — Fund der Funktionsprüfung vom 2026-09-22): Das `label` löst die
 * Dateiwahl von sich aus aus, ohne eine Zeile JavaScript, und das Feld trägt
 * seinen Namen dann selbst. Ein Knopf mit `ref.click()` wirkt nur im Browser
 * und in der Prüfung gar nicht.
 *
 * **Der Name steht daneben** — eine Datei mit ihrem Namen, mehrere mit ihrer
 * Zahl. Wo die Wahl sofort wirkt und die Seite selbst sagt, was gelesen wurde,
 * entfällt er (`ohneNamen`).
 */
export function Dateiwahl({
  beschriftung,
  aufWahl,
  accept,
  mehrere = false,
  gesperrt = false,
  ohneNamen = false,
  leeren = false,
  id,
  eingabe,
}: {
  /** Was auf dem Knopf steht — und damit der Name des Feldes. */
  beschriftung: string
  /** Die gewählten Dateien; leer, wenn die Auswahl abgebrochen wurde. */
  aufWahl: (dateien: File[]) => void
  accept?: string
  mehrere?: boolean
  gesperrt?: boolean
  /** Kein Dateiname daneben — die Seite sagt selbst, was gelesen wurde. */
  ohneNamen?: boolean
  /** Das Feld nach der Wahl leeren, damit dieselbe Datei noch einmal gewählt werden kann. */
  leeren?: boolean
  id?: string
  eingabe?: Ref<HTMLInputElement>
}) {
  const [gewaehlt, setGewaehlt] = useState<string | null>(null)

  return (
    <span className="dateiwahl">
      <label className={gesperrt ? 'knopf gesperrt' : 'knopf'}>
        {beschriftung}
        <input
          type="file"
          id={id}
          ref={eingabe}
          accept={accept}
          multiple={mehrere}
          disabled={gesperrt}
          onChange={(e) => {
            const dateien = [...(e.target.files ?? [])]
            setGewaehlt(
              dateien.length === 0
                ? null
                : dateien.length === 1
                  ? (dateien[0]?.name ?? null)
                  : t('dateiwahl.anzahl', { anzahl: anzahlwort(dateien.length) }),
            )
            aufWahl(dateien)
            if (leeren) {
              e.target.value = ''
            }
          }}
        />
      </label>
      {!ohneNamen && gewaehlt !== null && (
        <span className="dateiname" title={gewaehlt}>
          {gewaehlt}
        </span>
      )}
    </span>
  )
}
